import { createElement, remove, extend, getInstance, addClass, removeClass, select, isNullOrUndefined } from '@syncfusion/ej2-base';
import * as cls from '../base/css-constant';
import { Dialog } from '@syncfusion/ej2-popups';
import { MaskedTextBox, NumericTextBox } from '@syncfusion/ej2-inputs';
import { MultiSelect, CheckBoxSelection } from '@syncfusion/ej2-dropdowns';
import { PivotUtil } from '../../base/util';
import { PivotExportUtil } from '../../base/export-util';
import { CheckBox } from '@syncfusion/ej2-buttons';
import { DateTimePicker } from '@syncfusion/ej2-calendars';
import * as events from '../../common/base/constant';
/**
 * `Grouping` module to create grouping option for date, number and custom in popup.
 */
/** @hidden */
export class Grouping {
    /**
     * Constructor for the group UI rendering.
     *
     * @param {PivotView} parent - Instance.
     * @hidden
     */
    constructor(parent) {
        this.dateGroup = /_date_group_years|_date_group_quarters|_date_group_quarterYear|_date_group_months|_date_group_days|_date_group_hours|_date_group_minutes|_date_group_seconds/g;
        this.parent = parent;
        this.parent.groupingModule = this;
        this.addEventListener();
    }
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} - string
     * @private
     */
    getModuleName() {
        return 'grouping';
    }
    render(args) {
        const target = args.target;
        const option = args.option;
        const parentElement = args.parentElement;
        let selectedCellsInfo = [];
        this.parentElement = parentElement;
        this.isUpdate = false;
        const colIndex = parseInt(target.getAttribute('aria-colindex'), 10) - 1;
        const rowIndex = Number(target.getAttribute('index'));
        const cell = this.parent.engineModule.pivotValues[rowIndex][colIndex];
        const fieldName = cell.valueSort.axis.toString();
        selectedCellsInfo = this.getSelectedCells(cell.axis, fieldName, cell.actualText.toString());
        selectedCellsInfo.push({ axis: cell.axis, fieldName: fieldName, name: cell.actualText.toString(), cellInfo: cell });
        if (option.replace(parentElement.id, '').indexOf('_custom_group') !== -1) {
            this.createGroupSettings(fieldName, selectedCellsInfo);
        }
        else {
            this.updateUnGroupSettings(fieldName, selectedCellsInfo);
        }
    }
    /**
     * Returns the selected members/headers by checing the valid members from the pivot table.
     *
     * @function getSelectedOptions
     * @param  {SelectedCellsInfo[]} selectedCellsInfo - Get the members name from the given selected cells information
     * @returns {string[]} - string
     * @hidden
     */
    getSelectedOptions(selectedCellsInfo) {
        const selectedOptions = [];
        for (const option of selectedCellsInfo) {
            if (PivotUtil.inArray(option.name, selectedOptions) === -1) {
                selectedOptions.push(option.name);
            }
        }
        return selectedOptions;
    }
    createGroupSettings(fieldName, selectedCellsInfo) {
        const fieldList = this.parent.engineModule.fieldList[fieldName];
        const group = this.getGroupSettings(fieldName);
        if (selectedCellsInfo.length > 0) {
            let type;
            let isInvalid = false;
            if (fieldList.isCustomField) {
                if (!group) {
                    const dateGroup = this.getGroupSettings(fieldName.replace(this.dateGroup, ''));
                    const customGroup = this.getGroupSettings(fieldName.replace(/_custom_group/g, ''));
                    if (dateGroup) {
                        isInvalid = false;
                        type = 'date';
                        fieldName = fieldName.replace(this.dateGroup, '');
                    }
                    else if (customGroup) {
                        isInvalid = selectedCellsInfo.length === 1;
                        type = 'custom';
                    }
                }
                else if (group && group.type === 'Custom') {
                    if (selectedCellsInfo.length === 1) {
                        isInvalid = true;
                    }
                    else {
                        isInvalid = false;
                        type = 'custom';
                    }
                }
                else if (group && group.type === 'Number') {
                    isInvalid = false;
                    type = 'number';
                }
            }
            else {
                if (group) {
                    if (group.type === 'Number' || group.type === 'Date') {
                        isInvalid = false;
                        type = group.type === 'Date' ? 'date' : 'number';
                    }
                    else if (group.type === 'Custom') {
                        isInvalid = selectedCellsInfo.length === 1;
                        type = 'custom';
                    }
                }
                else {
                    if (fieldList.type === 'number' ||
                        (['datetime', 'date']).indexOf(fieldList.type) !== -1 || this.isDateType(fieldName)) {
                        isInvalid = false;
                        type = (selectedCellsInfo.length === 1 ? ((['datetime', 'date']).indexOf(fieldList.type) !== -1 ||
                            this.isDateType(fieldName)) ? 'date' : 'number' : 'custom');
                    }
                    else if (fieldList.type === 'string') {
                        isInvalid = selectedCellsInfo.length === 1;
                        type = 'custom';
                    }
                }
            }
            if (isInvalid) {
                this.parent.pivotCommon.errorDialog.createErrorDialog(this.parent.localeObj.getConstant('warning'), this.parent.localeObj.getConstant('invalidSelection'));
                this.parent.grid.clearSelection();
            }
            else if (type && type !== '') {
                this.createGroupDialog(fieldName, type, selectedCellsInfo);
            }
        }
    }
    updateUnGroupSettings(fieldName, selectedCellsInfo) {
        const fieldList = this.parent.engineModule.fieldList[fieldName];
        let groupFields = PivotUtil.cloneGroupSettings(this.parent.dataSourceSettings.groupSettings);
        const group = this.getGroupSettings(fieldName);
        if (selectedCellsInfo.length > 0) {
            let type;
            if (fieldList.isCustomField) {
                if (!group) {
                    const dateGroup = this.getGroupSettings(fieldName.replace(this.dateGroup, ''));
                    const customGroup = this.getGroupSettings(fieldName.replace(/_custom_group/g, ''));
                    if (dateGroup) {
                        type = 'date';
                        fieldName = fieldName.replace(this.dateGroup, '');
                    }
                    else if (customGroup) {
                        type = 'custom';
                    }
                }
                else if (group.type === 'Custom') {
                    type = 'custom';
                }
            }
            else {
                if (group) {
                    if (group.type === 'Number' || group.type === 'Date') {
                        type = group.type === 'Date' ? 'date' : 'number';
                    }
                }
            }
            if (type === 'date' || type === 'number') {
                groupFields = this.validateSettings(fieldName, groupFields, type, []);
            }
            else if (type === 'custom') {
                const selectedOptions = this.getSelectedOptions(selectedCellsInfo);
                groupFields = this.validateSettings(fieldName, groupFields, type, selectedOptions);
            }
            this.updateDateSource(groupFields, type);
        }
    }
    updateDateSource(groupFields, type) {
        if (this.isUpdate) {
            this.parent.setProperties({ dataSourceSettings: { groupSettings: groupFields } }, true);
            this.parent.updateGroupingReport(groupFields, (type === 'date' ? 'Date' : type === 'custom' ? 'Custom' : 'Number'));
            if (this.parent.dataSourceSettings.mode === 'Server') {
                this.parent.getEngine('onRefresh');
            }
            else {
                this.parent.initEngine();
            }
        }
    }
    removeGroupSettings(fieldName, selectedOptions, groupFields, groupNames) {
        const index = groupNames.indexOf(fieldName);
        if (index !== -1) {
            const field = groupFields[index];
            for (let j = 0, len = field.customGroups.length; j < len; j++) {
                if (field.customGroups[j]) {
                    const group = field.customGroups[j];
                    if (PivotUtil.inArray(group.groupName, selectedOptions) !== -1) {
                        groupFields = this.modifyParentGroupItems(fieldName, groupFields, [group.groupName], group.items, groupNames);
                        field.customGroups.splice(j, 1);
                        this.isUpdate = true;
                        j--;
                        len--;
                    }
                }
            }
        }
        delete this.parent.engineModule.groupingFieldsInfo[fieldName];
        return groupFields;
    }
    getGroupSettings(fieldName) {
        for (const group of this.parent.dataSourceSettings.groupSettings) {
            if (group.name === fieldName) {
                return group;
            }
        }
        return undefined;
    }
    isDateType(fieldName) {
        for (const format of this.parent.dataSourceSettings.formatSettings) {
            if (format.name === fieldName && format.type) {
                return true;
            }
        }
        return false;
    }
    /**
     * Returns the selected members/headers by checing the valid members from the pivot table.
     *
     * @function getSelectedCells
     * @param  {string} axis - Spicifies the axis name for the given field.
     * @param  {string} fieldName - Gets selected members for the given field name.
     * @param  {string} name - specifies the selected member name for the given field.
     * @returns {SelectedCellsInfo[]} - return type
     * @hidden
     */
    getSelectedCells(axis, fieldName, name) {
        const selectedCellsInfo = [];
        const selectedElements = this.parent.element.querySelectorAll('.' + cls.CELL_SELECTED_BGCOLOR + ',.' + cls.SELECTED_BGCOLOR);
        for (let i = 0; i < selectedElements.length; i++) {
            const element = selectedElements[i];
            const colIndex = parseInt(element.getAttribute('aria-colindex'), 10) - 1;
            const rowIndex = Number(element.getAttribute('index'));
            const cell = this.parent.engineModule.pivotValues[rowIndex][colIndex];
            if (cell && (cell.axis === axis) && !(cell.type === 'grand sum' || cell.type === 'sum') &&
                cell.valueSort.axis === fieldName && name !== cell.actualText.toString()) {
                selectedCellsInfo.push({
                    axis: cell.axis,
                    fieldName: cell.valueSort.axis.toString(),
                    name: cell.actualText.toString(),
                    cellInfo: cell
                });
            }
        }
        return selectedCellsInfo;
    }
    createGroupDialog(fieldName, type, selectedCellsInfo) {
        const groupDialogElement = createElement('div', {
            id: this.parentElement.id + '_GroupDialog',
            className: 'e-group-field-settings',
            attrs: { 'data-field': fieldName, 'data-type': type }
        });
        this.parentElement.appendChild(groupDialogElement);
        const groupDialog = new Dialog({
            animationSettings: { effect: 'Fade' },
            allowDragging: true,
            header: this.parent.localeObj.getConstant('grouping'),
            content: this.createGroupOptions(fieldName, type),
            isModal: true,
            visible: true,
            showCloseIcon: true,
            enableRtl: this.parent.enableRtl,
            locale: this.parent.locale,
            enableHtmlSanitizer: this.parent.enableHtmlSanitizer,
            width: 300,
            height: 'auto',
            position: { X: 'center', Y: 'center' },
            buttons: [
                {
                    click: this.updateGroupSettings.bind(this, selectedCellsInfo),
                    isFlat: false,
                    buttonModel: { cssClass: cls.OK_BUTTON_CLASS + (this.parent.cssClass ? (' ' + this.parent.cssClass) : ''), content: this.parent.localeObj.getConstant('ok'), isPrimary: true }
                },
                {
                    click: () => {
                        groupDialog.hide();
                    },
                    isFlat: false,
                    buttonModel: { cssClass: cls.CANCEL_BUTTON_CLASS + (this.parent.cssClass ? (' ' + this.parent.cssClass) : ''), content: this.parent.localeObj.getConstant('cancel') }
                }
            ],
            closeOnEscape: true,
            close: this.removeDialog.bind(this),
            target: this.parentElement,
            cssClass: this.parent.cssClass
        });
        groupDialog.isStringTemplate = true;
        groupDialog.appendTo(groupDialogElement);
    }
    createGroupOptions(fieldName, type) {
        const groupInstance = this;
        const mainDiv = createElement('div', {
            className: 'e-group-field-div-content', id: this.parentElement.id + '_group_field_div_content',
            attrs: { 'data-fieldName': fieldName, 'data-type': type }
        });
        const groupWrapperDiv1 = createElement('div', { className: 'e-group-option-container' });
        mainDiv.appendChild(groupWrapperDiv1);
        // this.parentElement.appendChild(mainDiv);
        const dataSource = this.parent.dataSourceSettings;
        const groupField = PivotUtil.getFieldByName(fieldName, dataSource.groupSettings);
        switch (type) {
            case 'custom':
                {
                    let caption;
                    let dataFields = dataSource.rows;
                    dataFields = dataFields.concat(dataSource.columns, dataSource.values, dataSource.filters);
                    let actualField = PivotUtil.getFieldByName(fieldName.replace(/_custom_group/g, ''), dataFields);
                    if (isNullOrUndefined(actualField) && !isNullOrUndefined(this.parent.clonedReport)) {
                        const clonedReport = this.parent.clonedReport;
                        let clonedDataFields = clonedReport.rows;
                        clonedDataFields = clonedDataFields.concat(clonedReport.columns, clonedReport.values, clonedReport.filters);
                        actualField = PivotUtil.getFieldByName(fieldName.replace(/_custom_group/g, ''), clonedDataFields);
                    }
                    const currentField = PivotUtil.getFieldByName(fieldName, dataFields);
                    const nextField = PivotUtil.getFieldByName(fieldName + '_custom_group', dataFields);
                    if (currentField) {
                        const newFieldName = fieldName + '_custom_group';
                        caption = nextField ? nextField.caption :
                            this.parent.engineModule.fieldList[actualField.name].caption + (newFieldName.match(/_custom_group/g).length + 1);
                    }
                    const captionInputTextDiv1 = createElement('div', {
                        className: 'e-caption-option-text'
                    });
                    captionInputTextDiv1.innerText = this.parent.localeObj.getConstant('groupFieldCaption');
                    const captionInputDiv1 = createElement('div', { className: 'e-group-caption-container' });
                    const captionInputField1 = createElement('input', {
                        id: this.parentElement.id + 'group_caption_option',
                        className: 'e-group-caption-text',
                        attrs: { 'type': 'text' }
                    });
                    captionInputDiv1.appendChild(captionInputTextDiv1);
                    captionInputDiv1.appendChild(captionInputField1);
                    groupWrapperDiv1.appendChild(captionInputDiv1);
                    const inputTextDiv1 = createElement('div', {
                        className: 'e-input-option-text'
                    });
                    inputTextDiv1.innerText = this.parent.localeObj.getConstant('groupTitle');
                    const inputDiv1 = createElement('div', { className: 'e-group-input-container' });
                    const inputField1 = createElement('input', {
                        id: this.parentElement.id + 'group_input_option',
                        className: 'e-group-input-text',
                        attrs: { 'type': 'text' }
                    });
                    inputDiv1.appendChild(inputTextDiv1);
                    inputDiv1.appendChild(inputField1);
                    groupWrapperDiv1.appendChild(inputDiv1);
                    const captionInputObj1 = new MaskedTextBox({
                        placeholder: this.parent.localeObj.getConstant('captionName'),
                        enableRtl: this.parent.enableRtl,
                        locale: this.parent.locale,
                        value: caption, width: '100%',
                        cssClass: this.parent.cssClass
                    });
                    captionInputObj1.isStringTemplate = true;
                    captionInputObj1.appendTo(captionInputField1);
                    const inputObj1 = new MaskedTextBox({
                        placeholder: this.parent.localeObj.getConstant('groupName'),
                        enableRtl: this.parent.enableRtl,
                        locale: this.parent.locale,
                        width: '100%',
                        cssClass: this.parent.cssClass
                    });
                    inputObj1.isStringTemplate = true;
                    inputObj1.appendTo(inputField1);
                }
                break;
            case 'date':
            case 'number':
                {
                    const startAtWrapper = createElement('div', {
                        className: 'e-group-start-option-container'
                    });
                    const startAtOptionDiv1 = createElement('input', {
                        id: this.parentElement.id + 'group_start_option',
                        className: 'e-group_start_option',
                        attrs: { 'type': 'checkbox' }
                    });
                    const startAtInputField1 = createElement('input', {
                        id: this.parentElement.id + 'group_start_input',
                        className: 'e-group_start_input',
                        attrs: { 'type': 'text' }
                    });
                    startAtWrapper.appendChild(startAtOptionDiv1);
                    startAtWrapper.appendChild(startAtInputField1);
                    groupWrapperDiv1.appendChild(startAtWrapper);
                    const endAtWrapper = createElement('div', {
                        className: 'e-group-end-option-container'
                    });
                    const endAtOptionDiv1 = createElement('input', {
                        id: this.parentElement.id + 'group_end_option',
                        className: 'e-group_end_option',
                        attrs: { 'type': 'checkbox' }
                    });
                    const endAtInputField1 = createElement('input', {
                        id: this.parentElement.id + 'group_end_input',
                        className: 'e-group_end_input',
                        attrs: { 'type': 'text' }
                    });
                    endAtWrapper.appendChild(endAtOptionDiv1);
                    endAtWrapper.appendChild(endAtInputField1);
                    groupWrapperDiv1.appendChild(endAtWrapper);
                    const intervalWrapper = createElement('div', {
                        className: 'e-group-interval-option-container'
                    });
                    const intervalTextDiv1 = createElement('div', {
                        className: 'e-group-inerval-option-text'
                    });
                    intervalTextDiv1.innerText = this.parent.localeObj.getConstant('groupBy');
                    const intervalInputField1 = createElement('input', {
                        id: this.parentElement.id + 'group_interval_input',
                        className: 'e-group_interval_input',
                        attrs: { 'type': 'text' }
                    });
                    intervalWrapper.appendChild(intervalTextDiv1);
                    intervalWrapper.appendChild(intervalInputField1);
                    groupWrapperDiv1.appendChild(intervalWrapper);
                    let startAt = undefined;
                    let endAt = undefined;
                    if (type === 'date') {
                        let selectedGroups = [];
                        const groupData = [
                            { value: 'Seconds', text: this.parent.localeObj.getConstant('Seconds') },
                            { value: 'Minutes', text: this.parent.localeObj.getConstant('Minutes') },
                            { value: 'Hours', text: this.parent.localeObj.getConstant('Hours') },
                            { value: 'Days', text: this.parent.localeObj.getConstant('Days') },
                            { value: 'Months', text: this.parent.localeObj.getConstant('Months') },
                            { value: 'QuarterYear', text: this.parent.localeObj.getConstant('QuarterYear') },
                            { value: 'Quarters', text: this.parent.localeObj.getConstant('Quarters') },
                            { value: 'Years', text: this.parent.localeObj.getConstant('Years') }
                        ];
                        if (groupField && groupField.type === 'Date') {
                            selectedGroups = groupField.groupInterval;
                            startAt = groupField.startingAt ? groupField.startingAt.toString() : undefined;
                            endAt = groupField.endingAt ? groupField.endingAt.toString() : undefined;
                        }
                        else {
                            selectedGroups = ['Months'];
                        }
                        const startAtInputObj = new DateTimePicker({
                            placeholder: this.parent.localeObj.getConstant('chooseDate'),
                            enableRtl: this.parent.enableRtl,
                            locale: this.parent.locale,
                            format: 'dd/MM/yyyy hh:mm:ss a',
                            enabled: !(startAt === undefined),
                            width: '100%',
                            cssClass: this.parent.cssClass
                        });
                        startAtInputObj.isStringTemplate = true;
                        startAtInputObj.appendTo(startAtInputField1);
                        const endAtInputObj = new DateTimePicker({
                            placeholder: this.parent.localeObj.getConstant('chooseDate'),
                            enableRtl: this.parent.enableRtl,
                            locale: this.parent.locale,
                            format: 'dd/MM/yyyy hh:mm:ss a',
                            enabled: !(endAt === undefined),
                            width: '100%',
                            cssClass: this.parent.cssClass
                        });
                        endAtInputObj.isStringTemplate = true;
                        endAtInputObj.appendTo(endAtInputField1);
                        MultiSelect.Inject(CheckBoxSelection);
                        const intervalObj = new MultiSelect({
                            dataSource: groupData,
                            value: selectedGroups,
                            fields: { text: 'text', value: 'value' },
                            mode: 'CheckBox',
                            showDropDownIcon: true,
                            enableSelectionOrder: false,
                            placeholder: this.parent.localeObj.getConstant('selectGroup'),
                            filterBarPlaceholder: this.parent.localeObj.getConstant('example') + ' ' + this.parent.localeObj.getConstant('Months'),
                            enableRtl: this.parent.enableRtl,
                            locale: this.parent.locale,
                            enableHtmlSanitizer: this.parent.enableHtmlSanitizer,
                            cssClass: this.parent.cssClass,
                            select: () => {
                                getInstance(select('#' + groupInstance.parentElement.id + '_GroupDialog', document), Dialog).element.querySelector('.' + cls.OK_BUTTON_CLASS).removeAttribute('disabled');
                            },
                            removed: () => {
                                const nodeList = intervalObj['liCollections'];
                                let activeListCount = 0;
                                nodeList.forEach((item) => {
                                    if (item.classList.contains('e-active')) {
                                        activeListCount++;
                                    }
                                });
                                if (activeListCount === 0) {
                                    getInstance(select('#' + groupInstance.parentElement.id + '_GroupDialog', document), Dialog).element.querySelector('.' + cls.OK_BUTTON_CLASS).setAttribute('disabled', 'disabled');
                                }
                            }
                        });
                        intervalObj.isStringTemplate = true;
                        intervalObj.appendTo(intervalInputField1);
                        startAtInputObj.value = startAt === undefined ? null : new Date(startAt);
                        startAtInputObj.dataBind();
                        endAtInputObj.value = endAt === undefined ? null : new Date(endAt);
                        endAtInputObj.dataBind();
                    }
                    else {
                        let selectedInterval = undefined;
                        if (groupField && groupField.type === 'Number') {
                            selectedInterval = groupField.rangeInterval;
                            startAt = groupField.startingAt ? groupField.startingAt.toString() : undefined;
                            endAt = groupField.endingAt ? groupField.endingAt.toString() : undefined;
                        }
                        else {
                            selectedInterval = 2;
                        }
                        const startAtInputObj = new NumericTextBox({
                            placeholder: this.parent.localeObj.getConstant('enterValue'),
                            enableRtl: this.parent.enableRtl,
                            locale: this.parent.locale,
                            showClearButton: true,
                            format: '###.##########',
                            value: startAt === undefined ? undefined : parseFloat(startAt),
                            enabled: !(startAt === undefined),
                            width: '100%',
                            cssClass: this.parent.cssClass
                        });
                        startAtInputObj.isStringTemplate = true;
                        startAtInputObj.appendTo(startAtInputField1);
                        const endAtInputObj = new NumericTextBox({
                            placeholder: this.parent.localeObj.getConstant('enterValue'),
                            enableRtl: this.parent.enableRtl,
                            locale: this.parent.locale,
                            showClearButton: true,
                            format: '###.##########',
                            value: endAt === undefined ? undefined : parseFloat(endAt),
                            enabled: !(endAt === undefined),
                            width: '100%',
                            cssClass: this.parent.cssClass
                        });
                        endAtInputObj.isStringTemplate = true;
                        endAtInputObj.appendTo(endAtInputField1);
                        const intervalObj = new NumericTextBox({
                            placeholder: this.parent.localeObj.getConstant('enterValue'),
                            enableRtl: this.parent.enableRtl,
                            locale: this.parent.locale,
                            showClearButton: true,
                            format: '###.##########',
                            min: 0,
                            value: selectedInterval,
                            width: '100%',
                            cssClass: this.parent.cssClass
                        });
                        intervalObj.isStringTemplate = true;
                        intervalObj.appendTo(intervalInputField1);
                    }
                    const startAtObj = new CheckBox({
                        label: this.parent.localeObj.getConstant('startAt'),
                        checked: !(startAt === undefined),
                        enableRtl: this.parent.enableRtl,
                        locale: this.parent.locale,
                        enableHtmlSanitizer: this.parent.enableHtmlSanitizer,
                        cssClass: this.parent.cssClass,
                        change: (args) => {
                            const startAtObj = (type === 'date' ?
                                getInstance(select('#' + this.parentElement.id + 'group_start_input'), DateTimePicker) :
                                getInstance(select('#' + this.parentElement.id + 'group_start_input'), NumericTextBox));
                            startAtObj.enabled = args.checked;
                            startAtObj.dataBind();
                        }
                    });
                    startAtObj.isStringTemplate = true;
                    startAtObj.appendTo(startAtOptionDiv1);
                    const endAtObj = new CheckBox({
                        label: this.parent.localeObj.getConstant('endAt'),
                        checked: !(endAt === undefined),
                        enableRtl: this.parent.enableRtl,
                        locale: this.parent.locale,
                        enableHtmlSanitizer: this.parent.enableHtmlSanitizer,
                        cssClass: this.parent.cssClass,
                        change: (args) => {
                            const endAtObj = (type === 'date' ?
                                getInstance(select('#' + this.parentElement.id + 'group_end_input'), DateTimePicker) :
                                getInstance(select('#' + this.parentElement.id + 'group_end_input'), NumericTextBox));
                            endAtObj.enabled = args.checked;
                            endAtObj.dataBind();
                        }
                    });
                    endAtObj.isStringTemplate = true;
                    endAtObj.appendTo(endAtOptionDiv1);
                }
                break;
        }
        return mainDiv;
    }
    updateGroupSettings(selectedCellsInfo) {
        const groupDialog = getInstance(select('#' + this.parentElement.id + '_GroupDialog', document), Dialog);
        const dialogElement = groupDialog.element;
        const groupType = dialogElement.getAttribute('data-type');
        const fieldName = dialogElement.getAttribute('data-field');
        let groupFields = PivotUtil.cloneGroupSettings(this.parent.dataSourceSettings.groupSettings);
        if (groupFields.length === 0 && !this.parent.clonedDataSet && !this.parent.clonedReport) {
            const dataSet = this.parent.engineModule.data;
            this.parent.clonedDataSet = this.parent.dataSourceSettings.type === 'CSV' ? PivotUtil.getClonedCSVData(dataSet) : PivotUtil.getClonedData(dataSet);
            this.parent.setProperties({ dataSourceSettings: { dataSource: [] } }, true);
            this.parent.clonedReport = extend({}, this.parent.dataSourceSettings, null, true);
            this.parent.setProperties({ dataSourceSettings: { dataSource: dataSet } }, true);
        }
        if (groupType === 'custom') {
            const inputInstance = getInstance(select('#' + this.parentElement.id + 'group_input_option'), MaskedTextBox);
            const captionInputInstance = getInstance(select('#' + this.parentElement.id + 'group_caption_option'), MaskedTextBox);
            removeClass([inputInstance.element], cls.EMPTY_FIELD);
            if (inputInstance.value === null || inputInstance.value === '') {
                addClass([inputInstance.element], cls.EMPTY_FIELD);
                inputInstance.element.focus();
                return;
            }
            const selectedOptions = this.getSelectedOptions(selectedCellsInfo);
            const customGroup = { groupName: inputInstance.value, items: selectedOptions };
            let splicedItems = [];
            let newItems = [];
            let field = { name: fieldName, caption: captionInputInstance.value, type: 'Custom', customGroups: [] };
            let isUpdated = false;
            for (let i = 0, len = groupFields.length; i < len; i++) {
                if (groupFields[i].name === fieldName) {
                    field = groupFields[i];
                    field.caption = captionInputInstance.value;
                    for (let j = 0, len = field.customGroups.length; j < len; j++) {
                        if (field.customGroups[j]) {
                            const group = field.customGroups[j];
                            if (group.items && PivotExportUtil.isContainCommonElements(group.items, selectedOptions)) {
                                splicedItems = this.mergeArray(splicedItems, [group.groupName]);
                                newItems = this.mergeArray(newItems, group.items);
                                field.customGroups.splice(j, 1);
                                j--;
                                len--;
                            }
                        }
                    }
                    for (const item of selectedOptions) {
                        const index = newItems.indexOf(item);
                        if (index !== -1) {
                            newItems.splice(index, 1);
                        }
                    }
                    newItems = this.mergeArray(newItems, [customGroup.groupName]);
                    field.customGroups.push(customGroup);
                    this.isUpdate = true;
                    isUpdated = true;
                    break;
                }
            }
            if (!isUpdated) {
                field.customGroups.push(customGroup);
                this.isUpdate = true;
                groupFields.push(field);
            }
            groupFields = this.validateSettings(fieldName, groupFields, groupType, (splicedItems.length === 0 ?
                customGroup.items : splicedItems), newItems);
        }
        else if (groupType === 'date' || groupType === 'number') {
            const startCheckBoxInstance = getInstance(select('#' + this.parentElement.id + 'group_start_option'), CheckBox);
            const endCheckBoxInstance = getInstance(select('#' + this.parentElement.id + 'group_end_option'), CheckBox);
            const startInputInstance = (groupType === 'date' ?
                getInstance(select('#' + this.parentElement.id + 'group_start_input'), DateTimePicker) :
                getInstance(select('#' + this.parentElement.id + 'group_start_input'), NumericTextBox));
            const endInputInstance = (groupType === 'date' ?
                getInstance(select('#' + this.parentElement.id + 'group_end_input'), DateTimePicker) :
                getInstance(select('#' + this.parentElement.id + 'group_end_input'), NumericTextBox));
            const intervalInstance = (groupType === 'date' ?
                getInstance(select('#' + this.parentElement.id + 'group_interval_input'), MultiSelect) :
                getInstance(select('#' + this.parentElement.id + 'group_interval_input'), NumericTextBox));
            const startAt = startCheckBoxInstance.checked ? startInputInstance.value.toString() : undefined;
            const endAt = endCheckBoxInstance.checked ? endInputInstance.value.toString() : undefined;
            const field = { name: fieldName, startingAt: startAt, endingAt: endAt };
            if (groupType === 'date') {
                const selectedItems = [];
                for (const list of intervalInstance.value) {
                    selectedItems.push(list);
                }
                field.type = 'Date';
                field.groupInterval = selectedItems;
            }
            else {
                field.type = 'Number';
                field.rangeInterval = intervalInstance.value;
            }
            let isUpdated = false;
            for (let i = 0, len = groupFields.length; i < len; i++) {
                if (groupFields[i].name === fieldName) {
                    groupFields.splice(i, 1, field);
                    this.isUpdate = true;
                    isUpdated = true;
                    break;
                }
            }
            if (!isUpdated) {
                this.isUpdate = true;
                groupFields.push(field);
            }
            groupFields = this.validateSettings(fieldName, groupFields, groupType, [], []);
        }
        groupDialog.close();
        this.updateDateSource(groupFields, groupType);
    }
    getGroupBasedSettings(groupFields) {
        const groups = {};
        for (const group of groupFields) {
            if (groups[group.type]) {
                groups[group.type].push(group);
            }
            else {
                groups[group.type] = [group];
            }
        }
        return groups;
    }
    getGroupByName(groupFields) {
        const customFields = {};
        for (const field of groupFields) {
            const name = field.name.replace(/_custom_group/g, '');
            if (customFields[name]) {
                customFields[name].push(field);
            }
            else {
                customFields[name] = [field];
            }
        }
        return customFields;
    }
    validateSettings(fieldName, groupFields, groupType, splicedItems, newItems) {
        let validatedSettings = [];
        const groups = this.getGroupBasedSettings(groupFields);
        const groupOrders = ['Date', 'Number', 'Custom'];
        if (groups[groupOrders[2]] && groupType === 'custom') {
            const customFields = this.getGroupByName(groups[groupOrders[2]]);
            if (customFields[fieldName.replace(/_custom_group/g, '')]) {
                let customGroups = customFields[fieldName.replace(/_custom_group/g, '')];
                const fields = customGroups.map((item) => item.name);
                if (newItems) {
                    customGroups = this.modifyParentGroupItems(fieldName, customGroups, splicedItems, newItems, fields);
                }
                else {
                    customGroups = this.removeGroupSettings(fieldName.replace('_custom_group', ''), splicedItems, customGroups, fields);
                }
            }
            let orderedGroups = [];
            for (const field of Object.keys(customFields)) {
                const fields = customFields[field].map((item) => item.name);
                orderedGroups = this.reOrderSettings(customFields[field], fields, orderedGroups, field, fieldName);
            }
            groups[groupOrders[2]] = orderedGroups;
        }
        else if ((groupType === 'date' || groupType === 'number') && !newItems) {
            const groupFields = groupType === 'date' ? groups[groupOrders[0]] : groups[groupOrders[1]];
            if (groupType === 'date') {
                groups[groupOrders[0]] = groupFields.filter((field) => { return field.name !== fieldName; });
                const groupingTypes = [
                    '_date_group_years',
                    '_date_group_quarters',
                    '_date_group_quarterYear',
                    '_date_group_months',
                    '_date_group_days',
                    '_date_group_hours',
                    '_date_group_minutes',
                    '_date_group_seconds'
                ];
                if (groups[groupOrders[0]].length === 0) {
                    delete this.parent.engineModule.groupingFieldsInfo[fieldName];
                    for (const key in this.parent.engineModule.groupingFieldsInfo) {
                        if (groupingTypes.some((dateTypes) => key === `${fieldName}${dateTypes}`)) {
                            delete this.parent.engineModule.groupingFieldsInfo[key];
                        }
                    }
                    for (const key in this.parent.engineModule.fieldList) {
                        if (groupingTypes.some((dateTypes) => key === `${fieldName}${dateTypes}`)) {
                            delete this.parent.engineModule.fieldList[key];
                        }
                    }
                    const updatedFields = this.parent.engineModule.fields.filter((item) => !groupingTypes.some((dateTypes) => item === `${fieldName}${dateTypes}`));
                    this.parent.engineModule.fields = updatedFields;
                }
            }
            else {
                groups[groupOrders[1]] = groupFields.filter((field) => { return field.name !== fieldName; });
            }
            this.isUpdate = true;
        }
        for (const order of groupOrders) {
            if (groups[order]) {
                validatedSettings = validatedSettings.concat(groups[order]);
            }
        }
        return validatedSettings;
    }
    reOrderSettings(customGroups, fields, orderedSettings, fieldName, groupedFieldName) {
        const index = fields.indexOf(fieldName);
        if (index > -1 && customGroups[index].customGroups && customGroups[index].customGroups.length > 0) {
            orderedSettings.push(customGroups[index]);
            this.reOrderSettings(customGroups, fields, orderedSettings, fieldName + '_custom_group');
        }
        else if (index > -1 && customGroups[index].customGroups && customGroups[index].customGroups.length === 0 &&
            !isNullOrUndefined(groupedFieldName)) {
            delete this.parent.engineModule.fieldList[groupedFieldName];
            delete this.parent.engineModule.groupingFieldsInfo[groupedFieldName];
            const updatedFields = this.parent.engineModule.fields.filter((value) => value !== groupedFieldName);
            this.parent.engineModule.fields = updatedFields;
        }
        return orderedSettings;
    }
    modifyParentGroupItems(fieldName, groupFields, splicedItems, newItems, fields) {
        const index = fields.indexOf(fieldName + '_custom_group');
        if (index !== -1) {
            const field = groupFields[index];
            if (field.customGroups && field.customGroups.length > 0) {
                for (let i = 0, len = field.customGroups.length; i < len; i++) {
                    if (field.customGroups[i]) {
                        let isItemsUpdated = false;
                        const group = field.customGroups[i];
                        if (group.items) {
                            for (const item of splicedItems) {
                                const pos = group.items.indexOf(item);
                                if (pos !== -1) {
                                    group.items.splice(pos, 1);
                                    this.isUpdate = true;
                                    isItemsUpdated = true;
                                }
                            }
                            if (isItemsUpdated) {
                                group.items = this.mergeArray(group.items, newItems);
                            }
                        }
                    }
                }
            }
        }
        return groupFields;
    }
    mergeArray(collection1, collection2) {
        const resultArray = [];
        const array = collection1.concat(collection2);
        let len = array.length;
        const assoc = {};
        while (len--) {
            const item = String(array[len]);
            if (!assoc[item]) {
                resultArray.unshift(item);
                assoc[item] = true;
            }
        }
        return resultArray;
    }
    removeDialog() {
        if ((this.parent.grid && this.parent.grid.isDestroyed) || isNullOrUndefined(this.parent.grid)) {
            return;
        }
        this.parent.grid.clearSelection();
        const element = select('#' + this.parent.element.id + '_GroupDialog', document);
        const groupDialog = element ? getInstance(element, Dialog) : null;
        if (groupDialog && !groupDialog.isDestroyed) {
            groupDialog.destroy();
        }
        if (this.parent.element && document.getElementById(this.parent.element.id + '_GroupDialog')) {
            remove(document.getElementById(this.parent.element.id + '_GroupDialog'));
        }
    }
    /**
     *
     * @returns {void}
     * @hidden
     */
    addEventListener() {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.on(events.initGrouping, this.render, this); //For initial rendering
    }
    /**
     *
     * @returns {void}
     * @hidden
     */
    removeEventListener() {
        if (this.parent.isDestroyed) {
            return;
        }
        this.removeDialog();
        this.parent.off(events.initGrouping, this.render);
    }
    /**
     * To destroy the pivot button event listener
     *
     * @returns {void}
     * @hidden
     */
    destroy() {
        this.removeEventListener();
    }
}
